import { render, staticRenderFns } from "./GTM8Date.vue?vue&type=template&id=4c89d6d3&"
import script from "./GTM8Date.vue?vue&type=script&lang=js&"
export * from "./GTM8Date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports